import { basicAxios } from "./basicAxios";

export const makePostTarballDownload = (fileName, fileData) =>
  basicAxios.post(
    "/api/tarball",
    {
      fileName,
      fileData,
    },
    { responseType: "blob" }
  );

export const makePostArchiveTarball = (data) =>
  basicAxios.post("/api/tarball/backup", { data });

export const makeGetArchiveTarballs = () =>
  basicAxios.get("/api/tarball/backup");

export const makeGetOneTarball = (key) =>
  basicAxios.get(
    "/api/tarball/download-one",
    { params: { key } },
    { responseType: "json" }
  );

export const makeDeleteListOfTarballs = (key) =>
  basicAxios.delete("/api/tarball/backup", { params: { key } });
